<style lang="scss" scoped>
  @import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
  .new-b2c-qc-report-tab {
    border-radius: 4px;
    .report-tab-tt {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 48px;
      .tt {
        color: #111;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        font-size: 28px;
      }
      .con {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 24px;
        color: #111;
        font-weight: 400;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 24px;
        &.hideCheckedIcon i {
          visibility: hidden;
        }
        .desc {
          color: #999;
        }
        .checked {
          color: #999;
        }
        .check-num {
          display: flex;
          align-items: center;
          img {
            width: 24px;
            height: 24px;
            margin-left: 24px;
            margin-right: 8px;
          }
        }

        .arrow {
          width: 24px;
          height: 24px;
          margin-left: 12px;
          vertical-align: top;
          transition: 0.3s;
        }
        .active-arrow {
          transform: rotateZ(180deg);
        }
      }
    }

    .content-wrap-show {
      height: auto;
      overflow: hidden;
    }

    .content-wrap-toggle {
      height: 0;
      overflow: hidden;
      &.active {
        height: auto;
        overflow: visible;
      }
    }
    .content-wrap-antoggle {
      height: auto;
      &.active {
        height: 0;
        overflow: hidden;
      }
    }
    .group-outer {
      margin-top: 28px;
      background: #fafafa;
      border-radius: 4px;
      font-size: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 300;
      color: #666666;
      line-height: 30px;
      padding: 12px 16px;
    }
    .tab-description {
      // width: 598px;
      // height: 118px;
      display: inline;
    }

    .explain-text {
      font-size: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 300;
      color: #666666;
      line-height: 30px;
      position: relative;
      display: inline-block;
      &::after {
        @include hairline(#666);
        border-bottom-width: 1px;
        top: calc(-50% - 6px);
      }
    }
  }
  .upgradeStyle-normal {
    margin-left: 20px !important;
  }
</style>

<template>
  <div class="new-b2c-qc-report-tab">
    <div class="report-tab-tt" @click="ttClick">
      <span class="tt">{{ title }}</span>
      <div class="con" :class="{ hideCheckedIcon: !$slots.default }">
        <div v-if="checkText" class="checked">{{ checkText }}</div>
        <template v-if="checkNumMap">
          <div v-if="!!checkNumMap.abNormalNum" class="check-num ab-normal upgradeStyle">
            <img
              src="https://pic5.zhuanstatic.com/zhuanzh/8d5b5a05-cad3-4718-a849-1aa6993b3777.png"
            />
            <span>{{ checkNumMap.abNormalNum }}项</span>
          </div>
          <div class="check-num normal upgradeStyle">
            <img
              v-if="checkNumMap.abNormalNum || checkNumMap.allPassText"
              class="upgradeStyle-normal"
              src="https://pic3.zhuanstatic.com/zhuanzh/ceeb00bd-f18e-47c1-bfb2-973ecf3bfe6e.png"
            />
            <span>
              {{
                checkNumMap.abNormalNum
                  ? `${checkNumMap.normalNum}项`
                  : checkNumMap.allPassText || `${checkNumMap.normalNum}项`
              }}
            </span>
          </div>
        </template>
        <span v-if="desc" class="desc">{{ desc }}</span>
        <img
          v-if="haveIcon"
          :src="'https://pic2.zhuanstatic.com/zhuanzh/f4135443-7e26-4149-a23c-03be938f667c.png'"
          :class="['arrow', { 'active-arrow': active }]"
        />
      </div>
    </div>
    <div
      v-if="groupExplain && itemId != 1 && tab.name != '外观检测'"
      class="group-outer"
      @click="openInfoDialog"
    >
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="tab-description" v-html="groupExplain"></div>
      <span v-if="tab.groupExplainPopUp" class="explain-text">查看详情</span>
    </div>

    <div class="content-wrap-show">
      <slot name="show"></slot>
    </div>
    <div class="content-wrap-toggle" :class="{ active }">
      <slot name="toggle"></slot>
    </div>
    <div class="content-wrap-antoggle" :class="{ active }">
      <slot name="antoggle"></slot>
    </div>

    <info-dialog
      v-if="tab.groupExplainPopUp"
      ref="deliveryDialogRef"
      :title="tab.groupExplainPopUp.title"
      :infoData="tab.groupExplainPopUp.repairPopUpInfo"
    />
  </div>
</template>
<script>
  import infoDialog from './info-dialog'
  export default {
    props: {
      dataInfo: {
        type: Object,
        default: () => {},
      },
      title: {
        type: String,
        default: '转转',
      },
      expanded: {
        type: Boolean,
        default: false,
      },
      checkText: {
        type: String,
        default: '',
      },
      desc: {
        type: String,
        default: '',
      },
      abNormalNum: {
        type: [String, Number],
        default: 0,
      },
      normalNum: {
        type: [String, Number],
        default: 0,
      },
      checkNumMap: {
        type: Object,
        default: null,
      },
      haveIcon: {
        type: Boolean,
        default: true,
      },
      tab: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    components: {
      infoDialog,
    },
    data() {
      return {
        active: false,
        deliveryDialogRef: null,
      }
    },
    computed: {
      groupExplain() {
        return this.tab.groupExplain
      },
      itemId() {
        return this.tab.itemId
      },
    },
    mounted() {
      this.active = this.expanded
    },
    methods: {
      ttClick() {
        this.active = !this.active
      },
      openInfoDialog() {
        this.$refs.deliveryDialogRef && this.$refs.deliveryDialogRef.open()
      },
    },
  }
</script>
